import React, { useContext, useEffect, useState } from 'react';
import { db } from 'src/firebase';
import { collection, getDocs, query } from 'firebase/firestore';
import { Pane, Card, Avatar, Text, Tooltip, InfoSignIcon } from 'evergreen-ui';
import { Loading } from 'src/components';
import AuthContext from 'src/providers/authProvider';
import useRedirectIfNotAuthorized from 'src/hooks/useIsAdminWithRedirect';
import Layout from 'src/layouts/Default';
import '../styles.css';
import SubscriberModal from 'src/components/SubscriberModal';

const SubscriberList = () => {
  const { loading } = useContext(AuthContext);
  useRedirectIfNotAuthorized();
  const [subscribers, setSubscribers] = useState([]);
  const [selectedSubscriber, setSelectedSubscriber] = useState(null);
  const [areSubscribersLoading, setAreSubscribersLoading] = useState(true);
  const getSubscribers = async () => {
    const q = await query(collection(db, 'subscribers'));
    const snapshot = await getDocs(q);
    setSubscribers(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    setAreSubscribersLoading(false);
  };

  const categories = subscribers.reduce((acc, subscriber) => {
    if (subscriber.category && !acc.includes(subscriber.category)) {
      acc.push(subscriber.category);
    }
    return acc;
  }, []);

  useEffect(() => {
    getSubscribers();
  }, []);

  const onGoBack = () => {
    window.history.back();
  };

  const onSave = (newSubscriber) => {
    const newSubscribers = structuredClone(subscribers).map((subscriber) => {
      if (subscriber.email === newSubscriber.email) {
        return newSubscriber;
      }
      return subscriber;
    });
    setSubscribers(newSubscribers);
    setSelectedSubscriber(null);
  };

  if (loading || areSubscribersLoading) {
    return <Loading />;
  }

  return (
    <Layout title={`Subscribers (${subscribers.length})`} actionButtonProps={{ onBack: onGoBack }} maxWidth={540}>
      <SubscriberModal
        categories={categories}
        isOpen={selectedSubscriber !== null}
        subscriber={selectedSubscriber}
        onClose={() => setSelectedSubscriber(null)}
        onSave={onSave}
      />
      <Card elevation={1} padding="30px" width={540} maxWidth="100%" display="flex" flexDirection="column" gap="24px" wordBreak="break-all">
        {subscribers.map((subscriber) => (
          <Pane key={subscriber.id} display="flex" alignItems="center" gap="12px" cursor="pointer" onClick={() => setSelectedSubscriber(subscriber)}>
            <Avatar name={subscriber.email} size={26} />
            <Pane display="flex" flexDirection="column">
              <Text>{subscriber.email}</Text>
              {subscriber.category && (
                <Text color="gray500" size={300}>
                  {subscriber.category}
                </Text>
              )}
            </Pane>

            {subscriber.notes && (
              <Tooltip content={subscriber.notes}>
                <InfoSignIcon marginLeft="auto" />
              </Tooltip>
            )}
          </Pane>
        ))}
      </Card>
    </Layout>
  );
};

export default SubscriberList;
